import classNames from 'classnames';

export const ColumnSeparator = () => (
  <div className='absolute right-0 top-0 h-full w-px pointer-events-none bg-gray-concrete' />
);

type ColumnResizeHandleProps = {
  isResizing: boolean;
  resizeHandler: (e: unknown) => void;
  canResize?: boolean;
};

export const ColumnResizeHandle = ({ isResizing, resizeHandler, canResize = true }: ColumnResizeHandleProps) => (
  <div
    className={classNames(
      'group/handle absolute right-0 top-0 h-full w-4 select-none touch-none z-[1] flex items-center justify-center transition-colors',
      canResize
        ? classNames('cursor-col-resize', { 'bg-gray-mercury': isResizing, 'hover:bg-gray-concrete': !isResizing })
        : 'pointer-events-none',
    )}
    onMouseDown={canResize ? (e) => resizeHandler(e) : undefined}
    onTouchStart={canResize ? (e) => resizeHandler(e) : undefined}
  >
    <div
      className={classNames('self-stretch w-px pointer-events-none', {
        'bg-gray-silver-chalice': isResizing || !canResize,
        'bg-[repeating-linear-gradient(to_bottom,#CCCCCC_0px,#CCCCCC_3px,transparent_3px,transparent_6px)]':
          !isResizing && canResize,
      })}
    />
  </div>
);
